import types from '../actions/types';

const INITIAL_STATE = {
  orderInfo: {},
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.SET_ORDER_INFO:
      return {
        ...state,
        orderInfo: action.payload,
      };
    default:
      return state;
  }
}
